import { ActiveChannels } from '../../components/common/channelsEnum';

export interface Environments {
  clientId: string;
  clientSecret: string;
  title: string;
}

export interface EnvironmentSettingsItem {
  envId: string;
  secureMode: boolean;
  usageLimit: {
    [key in ActiveChannels | 'GENERAL']?: number;
  };
  accountType: AccountType;
  verification: AccountVerification[];
}

export enum AccountType {
  FREE = 'FREE',
  PAID = 'PAID'
}

export enum AccountVerification {
  EMAIL_CONFIRMATION = 'EMAIL_CONFIRMATION',
  PAYMENT_METHOD = 'PAYMENT_METHOD',
  DOMAIN_VERIFICATION = 'DOMAIN_VERIFICATION'
}

export const DefaultUsage = {
  SMS: 100,
  CALL: 100,
  GENERAL: 10000
};

export const defaultEnvironmentSettings: EnvironmentSettingsItem = {
  envId: '',
  secureMode: false,
  usageLimit: DefaultUsage,
  accountType: AccountType.FREE,
  verification: []
};

export interface UsageItem {
  envIdChannel: string;
  yearMonth: string;
  channelUsage: number;
}
